import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { STR_MENU_INQUIRIES, STR_NO_RECORD, STR_SEARCH_HERE } from "../Strings";
import { MdSearch } from 'react-icons/md';
import OneOrder from "../ones/OneOrder";

export default function View(props) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);
	const [filter, setFilter] = useState("");

	async function init() {
		setReady(false);
		await appContext.getMyOrders();
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	if (ready) {
		const orders = appContext.myOrders || [];
		const normalizedFilter = filter.trim().toLowerCase();
		const filteredOrders = orders.filter((item) => {
			if (!normalizedFilter) return true;
			return String(item.title || "").toLowerCase().includes(normalizedFilter);
		});

		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6 className="main-section-title">
								{STR_MENU_INQUIRIES[appContext.language]}
								<br/>
								({orders.length})
							</h6>
						</div>

						<div className="col-md-12">
							<div className="input-group mb-4">
								<span
									className="input-group-text font-semi-bold text-secondary"
									style={{ fontSize: "16px" }}
								>
									<MdSearch size={24}/>
								</span>
								<input
									className="form-control"
									onChange={(e) => setFilter(e.target.value)}
									value={filter}
									maxLength={100}
									placeholder={STR_SEARCH_HERE[appContext.language]}
									type="text"
									style={{ fontSize: "16px" }}
								/>
							</div>

							{
								(filteredOrders.length > 0) ?
								filteredOrders.map((item) => (
									<OneOrder data={item} key={item.uuid}/>
								))
								:
								<h6>{STR_NO_RECORD[appContext.language]}</h6>
							}
						</div>
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
}
